/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Discount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Amount from './Amount/index'
import ApplyTo from './ApplyTo/index'
import IsIncludedInClaim from './IsIncludedInClaim/index'
import Payor from './Payor/index'
import Percentage from './Percentage/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import Type from './Type/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Discount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Discounts/Content/Discount"
  
}) {
let discountItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'discount_item',
path: 'isFirst',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="Discount.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-oolC6': discountItemIsFirstValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ApplyTo
  viewPath={`${viewPath}/ApplyTo`}
/>
<Payor
  viewPath={`${viewPath}/Payor`}
/>
<IsIncludedInClaim
  viewPath={`${viewPath}/IsIncludedInClaim`}
/>
</div>
<div
  data-testid="Discount.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-oolC6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Amount
  viewPath={`${viewPath}/Amount`}
/>
<div
  data-testid="Discount.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 color={dtColorsBlack}
 text="or"
/>
</div>
<Percentage
  viewPath={`${viewPath}/Percentage`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
{children}
</React.Fragment>)
}